// ---------------------------------------------------------------------------
// Teacher-Exams module — locale messages.
// Merged into the global i18n instance at bootstrap time.
// ---------------------------------------------------------------------------

export const teacherExamsMessages = {
  'de-AT': {
    teacher_exams: {
      title: 'Meine Prüfungen',
      subtitle: 'Übersicht Ihrer vorgeschlagenen und freigegebenen Prüfungstermine.',
      propose_button: 'Neuen Termin vorschlagen',
      empty: 'Noch keine Prüfungen vorgeschlagen.',
      columns: {
        subject: 'Fach',
        exam_date: 'Termin',
        duration: 'Dauer',
        location: 'Ort',
        exam_type: 'Art',
        exam_mode: 'Modus',
        status: 'Status',
        subscribers: 'Anmeldungen',
        actions: 'Aktionen',
      },
      actions: {
        open_subscribers: 'Angemeldete anzeigen',
      },
      propose: {
        title: 'Neuen Prüfungstermin vorschlagen',
        subject: 'Fach',
        subject_placeholder: 'Fach wählen',
        exam_date: 'Prüfungsdatum',
        duration_minutes: 'Dauer (Minuten)',
        location: 'Ort',
        location_placeholder: 'z. B. HS 1, Online, ...',
        exam_type: 'Prüfungsart',
        exam_mode: 'Prüfungsmodus',
        max_score: 'Maximalpunkte',
        passing_score: 'Bestehenspunkte',
        notes: 'Anmerkungen',
        subscription_deadline: 'Anmeldeschluss (optional)',
        submit: 'Vorschlagen',
        cancel: 'Abbrechen',
      },
      subscribers: {
        title: 'Angemeldete Studierende',
        empty: 'Keine Anmeldungen vorhanden.',
        columns: {
          subscription_id: 'Anmelde-ID',
          student: 'Student/in',
          subscribed_at: 'Angemeldet am',
          state: 'Status',
        },
        state: {
          active: 'Aktiv',
          withdrawn: 'Zurückgezogen',
          blocked: 'Gesperrt',
        },
        close: 'Schließen',
      },
      status: {
        proposed: 'Vorgeschlagen',
        accepted: 'Freigegeben',
        rejected: 'Abgelehnt',
        completed: 'Abgeschlossen',
        cancelled: 'Storniert',
      },
      exam_type: {
        regular: 'Regulär',
        resit: 'Wiederholung',
        admission_test: 'Aufnahmeprüfung',
        vwa_submission: 'VWA-Abgabe',
        final_exam_component: 'Reifeprüfungsteil',
      },
      exam_mode: {
        written: 'Schriftlich',
        oral: 'Mündlich',
        final_paper: 'Abschlussarbeit',
        combined: 'Kombiniert',
      },
      toast: {
        proposed_title: 'Prüfungstermin vorgeschlagen',
        proposed_detail: 'Der Termin wartet auf Freigabe durch die Verwaltung.',
        propose_failed_title: 'Vorschlag fehlgeschlagen',
        propose_failed_detail: 'Der Termin konnte nicht gespeichert werden.',
      },
      validation: {
        date_in_past: 'Das Prüfungsdatum muss in der Zukunft liegen.',
        subject_required: 'Bitte wählen Sie ein Fach.',
      },
    },
  },
  en: {
    teacher_exams: {
      title: 'My Exams',
      subtitle: 'Overview of your proposed and approved exam dates.',
      propose_button: 'Propose new date',
      empty: 'No exams proposed yet.',
      columns: {
        subject: 'Subject',
        exam_date: 'Date',
        duration: 'Duration',
        location: 'Location',
        exam_type: 'Type',
        exam_mode: 'Mode',
        status: 'Status',
        subscribers: 'Subscribers',
        actions: 'Actions',
      },
      actions: {
        open_subscribers: 'Show subscribers',
      },
      propose: {
        title: 'Propose new exam date',
        subject: 'Subject',
        subject_placeholder: 'Select subject',
        exam_date: 'Exam date',
        duration_minutes: 'Duration (minutes)',
        location: 'Location',
        location_placeholder: 'e.g. HS 1, Online, ...',
        exam_type: 'Exam type',
        exam_mode: 'Exam mode',
        max_score: 'Max score',
        passing_score: 'Passing score',
        notes: 'Notes',
        subscription_deadline: 'Subscription deadline (optional)',
        submit: 'Propose',
        cancel: 'Cancel',
      },
      subscribers: {
        title: 'Registered students',
        empty: 'No subscriptions.',
        columns: {
          subscription_id: 'Subscription ID',
          student: 'Student',
          subscribed_at: 'Subscribed at',
          state: 'State',
        },
        state: {
          active: 'Active',
          withdrawn: 'Withdrawn',
          blocked: 'Blocked',
        },
        close: 'Close',
      },
      status: {
        proposed: 'Proposed',
        accepted: 'Approved',
        rejected: 'Rejected',
        completed: 'Completed',
        cancelled: 'Cancelled',
      },
      exam_type: {
        regular: 'Regular',
        resit: 'Resit',
        admission_test: 'Admission test',
        vwa_submission: 'VWA submission',
        final_exam_component: 'Final-exam component',
      },
      exam_mode: {
        written: 'Written',
        oral: 'Oral',
        final_paper: 'Final paper',
        combined: 'Combined',
      },
      toast: {
        proposed_title: 'Exam date proposed',
        proposed_detail: 'The date is awaiting approval by the administration.',
        propose_failed_title: 'Proposal failed',
        propose_failed_detail: 'The date could not be saved.',
      },
      validation: {
        date_in_past: 'Exam date must be in the future.',
        subject_required: 'Please choose a subject.',
      },
    },
  },
} as const;
